import { composeFieldPath } from '@northfork/basics'
import { BulkExternalData } from '../bulk-misc-model'
import { TransactionTypeLabel } from '../bulk-transaction'
export const wireField = composeFieldPath([] as BulkWireTransferRow[])

export interface BulkWireTransferRow extends BulkExternalData {
  rowId: string
  rowNumber?: string
  cusip: string
  entryDate: string
  sourceAccountId: string
  sourcePostDate: string
  sourceCleared: boolean
  destAccountId: string
  destPostDate: string
  destCleared: boolean
  amount?: string
  units: string
  validityStatus: 'valid' | 'invalid' | 'warning' | 'inactive' | 'intermediate'
  errorMessageMap: Map<string, string[]>
  legacyOrigTranId?: number
  sleeveAccountId?: number
  orderId?: string
  transactionTypeLabel?: TransactionTypeLabel
}

export interface ErrorMessageRow {
  field: string
  errorMessages: string[]
}
